import { render, staticRenderFns } from "./NavBarAdmin.vue?vue&type=template&id=ff874ecc&scoped=true&"
import script from "./NavBarAdmin.vue?vue&type=script&lang=js&"
export * from "./NavBarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NavBarAdmin.vue?vue&type=style&index=0&id=ff874ecc&scoped=true&lang=scss&"
import style1 from "./NavBarAdmin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff874ecc",
  null
  
)

export default component.exports